'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inclusion = require('./inclusion');

var _helpers = require('./helpers');

var exclusion = (0, _helpers.memoize)(function (options) {
  return (0, _inclusion.inclusionExclusion)(false, options);
});

exports.default = exclusion;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form-validators/lib/exclusion.js
// module id = 953
// module chunks = 0